import { useGetPerson } from '@my-pages/hooks/useGetPerson';
import { MembershipFeePageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import { smoothScroll } from '@shared/utils/misc';
import { useEffect, useState } from 'react';
import MemberFeeForm from "@my-pages/features/member-fee/components/MemberFeeForm.tsx";
import MemberFee from "@my-pages/features/member-fee/components/MemberFee.tsx";

interface IMemberFeePageProps {
    content: MembershipFeePageContentResponseModel;
}
//@ts-ignore
const MemberFeePage = ({ content }: IMemberFeePageProps) => {
    const member = useGetPerson();
    const [displayForm, setDisplayForm] = useState(false);

    useEffect(() => {
        smoothScroll(0);
    }, [displayForm]);

    if (!member) return <></>;
    return displayForm ? (
        <MemberFeeForm
            content={content}
            member={member}
            closeForm={() => setDisplayForm(false)}
        />
    ) : (
        <MemberFee
            content={content}
            member={member}
            openForm={() => setDisplayForm(true)}
        />
    );
};

export default MemberFeePage;
